<div class="pb-loading">
  <div class="pb-loading__header">
    <span class="pb-loading__title">
      <mat-icon class="pb-loading__cal-icon">calendar_today</mat-icon>
      {{ title }}
    </span>
  </div>
  <div class="pb-loading__body">
    <mat-progress-spinner mode="indeterminate" [diameter]="44" [strokeWidth]="4" color="primary">
    </mat-progress-spinner>
    <div class="pb-loading__message">{{ message }}</div>
    <div class="pb-loading__hint">{{ hint }}</div>
  </div>
</div>
